document.addEventListener("DOMContentLoaded", (event) => {
 const addToCartBtnList = document.querySelectorAll('.add-to-cart');
  Array.from(addToCartBtnList).forEach((addToCartBtn) => {
    addToCartBtn.addEventListener('click', (event) => {
      const form = document.querySelector('.js-product-form');
      const sizeField = document.querySelector('[data-option="Size"]');
      const isSizeSelected = sizeField?.querySelector('input[type="radio"]:checked');
      const isValidForm = form.checkValidity();

      if(sizeField) {
        if (isValidForm === false || !!isSizeSelected === false) {
          event.preventDefault();
          const errorNotif = document.querySelector('#no-size-selected');
          errorNotif.classList.add('show')
          const variantPicker = document.querySelector('variant-picker');
          event.preventDefault();
          if(window.screen.width < 768) {
              errorNotif.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
          } else {
              if(addToCartBtn.classList.contains('sticky-btn')) {
                errorNotif.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              } 
          }
        }
    }
      
    });
  });
});



